import { render, staticRenderFns } from "./BannerLong.vue?vue&type=template&id=7595d10a&scoped=true"
import script from "./BannerLong.vue?vue&type=script&lang=js"
export * from "./BannerLong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7595d10a",
  null
  
)

export default component.exports